{
  "title": "Impostazioni",
  "tabs": {
    "provider": "Provider",
    "connection": "Connessione",
    "appearance": "Aspetto",
    "agent": "Agente",
    "features": "Funzioni",
    "mcp": "MCP"
  },
  "appearance": {
    "themeHeading": "Tema",
    "themeLight": "Chiaro",
    "themeDark": "Scuro",
    "themeSystem": "Sistema",
    "themeSystemHint": "Sistema segue la tua preferenza chiaro/scuro a livello di sistema operativo.",
    "preferencesHeading": "Preferenze",
    "compactDensity": "Densità compatta",
    "compactDensityHint": "Spaziatura più stretta in tutta la chat.",
    "soundOnComplete": "Suono al completamento",
    "soundOnCompleteHint": "Riproduci un leggero suono al termine di un'esecuzione.",
    "titleAnimation": "Animazione del titolo",
    "titleAnimationHint": "Mostra il titolo animato del terminale nella CLI.",
    "languageHeading": "Lingua",
    "languageLabel": "Lingua dell'interfaccia",
    "languageHint": "Modifica solo il testo dell'interfaccia. I prompt, le skill e l'output del modello non sono interessati."
  },
  "model": {
    "heading": "Modello",
    "loading": "Caricamento modelli...",
    "notFound": "Nessun modello trovato per questo provider. Il catalogo potrebbe essere vuoto o ancora in caricamento.",
    "selectProviderFirst": "Seleziona prima un provider",
    "context": "{{count}}k contesto"
  },
  "connection": {
    "wsUrlLabel": "URL del server WebSocket",
    "wsUrlPlaceholder": "ws://localhost:3457",
    "wsUrlHint": "URL del server WebSocket dell'agente. Il server viene eseguito insieme alla CLI.",
    "startingHeading": "Avviare il server WebSocket",
    "startingBody": "Autonomo: esegui ./dev.ps1 dalla root del repo, oppure imposta WS_HOST/WS_PORT prima di avviare wstackui. Oppure alongside la CLI: wstack --webui."
  },
  "provider": {
    "subscriptionHeading": "Accesso con abbonamento",
    "apiKeysHeading": "Provider con chiave API",
    "apiKeysBody": "Scegli un provider dal catalogo e aggiungi una chiave API, oppure gestisci i provider salvati.",
    "tabCatalog": "Catalogo",
    "tabSaved": "Salvati ({{count}})",
    "searchPlaceholder": "Cerca tra {{count}} provider (nome / id / famiglia)…",
    "loadingCatalog": "Caricamento catalogo...",
    "noMatch": "Nessun provider corrisponde a \"{{query}}\".",
    "configured": "Configurato",
    "reachable": "Raggiungibile",
    "envVar": "ENV: {{var}}",
    "modelCount_one": "{{count}} modello",
    "modelCount_other": "{{count}} modelli",
    "keyPlaceholder": "Chiave API {{name}}",
    "orEnv": "Oppure imposta {{env}} nell'ambiente.",
    "addApiKey": "Aggiungi chiave API",
    "manageKeys": "Gestisci le tue chiavi API e le configurazioni dei provider",
    "addProvider": "Aggiungi provider",
    "addCustomHeading": "Aggiungi provider personalizzato",
    "localServers": "Server locali — clicca per precompilare:",
    "providerIdPlaceholder": "ID provider (es. my-llm-server)",
    "apiKeyOptionalPlaceholder": "Chiave API (facoltativa)",
    "noSaved": "Nessun provider salvato",
    "noSavedHint": "Aggiungi un provider per iniziare",
    "apiKeysLabel": "Chiavi API",
    "addKey": "Aggiungi chiave",
    "noKeys": "Nessuna chiave configurata",
    "active": "Attiva",
    "setActive": "Imposta come attiva",
    "keyLabelPlaceholder": "Etichetta chiave (es. default, production)",
    "apiKeyPlaceholder": "Chiave API",
    "saveKey": "Salva chiave",
    "savedToast": "Chiave salvata per {{name}}"
  },
  "mcp": {
    "status": {
      "connected": "Connesso",
      "connecting": "Connessione",
      "sleeping": "In pausa",
      "discovering": "Rilevamento",
      "error": "Errore",
      "stopped": "Fermo",
      "unknown": "Sconosciuto"
    },
    "disabled": "I server MCP sono disabilitati.",
    "wakeTitle": "Riattiva server",
    "sleepTitle": "Metti in pausa",
    "discoverTitle": "Scopri strumenti",
    "editTitle": "Modifica",
    "removeTitle": "Rimuovi",
    "statusLabel": "Stato:",
    "enabledLabel": "Attivo:",
    "yes": "Sì",
    "no": "No",
    "descriptionLabel": "Descrizione:",
    "pidLabel": "PID:",
    "errorLabel": "Errore:",
    "toolsLabel": "Strumenti ({{count}}):",
    "noTools": "Nessuno strumento ancora scoperto",
    "serverNameRequired": "Il nome del server è obbligatorio",
    "dialogTitleEdit": "Modifica server MCP",
    "dialogTitleAdd": "Aggiungi server MCP",
    "dialogTitleAddCustom": "Aggiungi server MCP personalizzato",
    "fieldName": "Nome",
    "fieldNamePlaceholder": "es. github, filesystem",
    "fieldTransport": "Trasporto",
    "fieldUrl": "URL",
    "fieldCommand": "Comando",
    "fieldCommandPlaceholder": "es. npx",
    "fieldArgs": "Args",
    "fieldArgsHint": "(separati da spazi)",
    "fieldArgsPlaceholder": "es. -y @modelcontextprotocol/server-github",
    "fieldEnv": "Variabili d'env",
    "fieldEnvHint": "(KEY=valore, una per riga)",
    "fieldDescription": "Descrizione",
    "fieldDescriptionPlaceholder": "Server MCP GitHub per l'accesso al repository",
    "enableServer": "Abilita server",
    "lazyConnect": "Connessione pigra",
    "lazyConnectHint": "(non avviare fino alla prima chiamata; va in pausa quando inattivo)",
    "saveChanges": "Salva modifiche",
    "addServer": "Aggiungi server",
    "requires": "Richiede: {{vars}}",
    "added": "Aggiunto",
    "heading": "Server MCP",
    "summary": "{{connected}} connessi · {{sleeping}} in pausa · {{total}} totali",
    "addCustom": "Personalizzato",
    "tabRecommended": "Consigliati",
    "tabServers": "Server",
    "tabAddCustom": "Personalizzato",
    "recommendedBody": "Aggiunta con un clic per i server MCP popolari. Clicca Aggiungi per precompilare la configurazione, poi conferma. I server che richiedono credenziali avranno bisogno delle variabili d'env prima dell'uso.",
    "loadingServers": "Caricamento server...",
    "noServers": "Nessun server MCP configurato",
    "noServersHint": "Passa alla scheda Consigliati per aggiungere server popolari, oppure Personalizzato per i tuoi.",
    "addCustomBody": "Configura un server MCP personalizzato con trasporto stdio, SSE o HTTP.",
    "addCustomBodyHint": "Per i server popolari usa invece la scheda Consigliati — è tutto preconfigurato.",
    "removeConfirmTitle": "Rimuovere il server \"{{name}}\"?",
    "removeConfirmBody": "Questo rimuove il server MCP dalla tua configurazione.",
    "toastAdded": "Server \"{{name}}\" aggiunto",
    "toastRemoved": "Server \"{{name}}\" rimosso",
    "toastDiscovered": "Scoperti {{count}} strumenti da \"{{name}}\"",
    "toastSleeping": "Il server \"{{name}}\" è in pausa",
    "toastConnected": "Server \"{{name}}\" connesso",
    "toastReconnected": "Server \"{{name}}\" riconnesso",
    "toastDisconnected": "Server \"{{name}}\" disconnesso: {{reason}}",
    "toastError": "Server \"{{name}}\" errore: {{error}}",
    "disabledHint": "Abilita il flag \"Server MCP\" nella scheda Funzionalità per usare questa sezione."
  },
  "allowlist": {
    "title": "Cancella l'allowlist salvata?",
    "body_one": "Questo rimuoverà il modello fissato per {{provider}}. Il selettore modelli tornerà al catalogo models.dev.",
    "body_other": "Questo rimuoverà i {{count}} modelli fissati per {{provider}}. Il selettore modelli tornerà al catalogo models.dev.",
    "undoHint": "Puoi annullare per 8 secondi dopo la conferma.",
    "keepTitle": "Mantieni allowlist (Esc)",
    "clearTitle": "Cancella allowlist (Invio)",
    "clear": "Cancella allowlist"
  },
  "oauth": {
    "termsWarning": "Accedi con un abbonamento invece di una chiave API. Usare un abbonamento al di fuori del suo client ufficiale può violare i Termini del provider — il tuo account potrebbe essere rate-limited o bannato. Una chiave API è la via sanzionata per uso programmatico.",
    "signIn": "Accedi",
    "waitingBrowser": "In attesa del tuo accesso…",
    "openSignIn": "Apri pagina di accesso",
    "pasteLoopbackBusy": "Porta loopback occupata — incolla l'URL di reindirizzamento",
    "pasteCantReach": "Il browser non raggiunge questo server? Incolla l'URL di reindirizzamento",
    "submit": "Invia",
    "enterCode": "Inserisci questo codice nella pagina di verifica:",
    "openVerification": "Apri pagina di verifica",
    "waitingCode": "In attesa di autorizzazione…",
    "exchanging": "Scambio token…",
    "fetchingModels": "Recupero modelli…",
    "signedIn": "Accesso effettuato.",
    "signedInToast": "Accesso effettuato — {{provider}}",
    "signInFailed": "Accesso fallito"
  },
  "agent": {
    "modelHeading": "Modello",
    "autonomyHeading": "Autonomia e Comportamento",
    "autonomyModeLabel": "Modalità autonomia",
    "autonomyModeHint": "Quanto indipendentemente l'agent procede tra i turni.",
    "autonomyModeOff": "Off — controllo manuale completo",
    "autonomyModeSuggest": "Suggerisci — suggerisce i passaggi successivi",
    "autonomyModeAuto": "Auto — breve ritardo di conferma",
    "autonomyModeEternal": "Eterno — autonomo fino al completamento dell'obiettivo",
    "autonomyModeEternalParallel": "Eterno Parallelo — flotta multi-agente",
    "autoProceedDelayLabel": "Ritardo auto-procedere",
    "autoProceedDelayHint": "Millisecondi prima che l'agent proceda automaticamente in modalità Auto. 0 = immediato.",
    "yoloLabel": "Modalità YOLO",
    "yoloHint": "Ignora i prompt di conferma degli strumenti — l'agent gira senza chiedere.",
    "refineHeading": "Affinamento Prompt",
    "enableRefineLabel": "Abilita affinamento",
    "enableRefineHint": "Riscrivi i prompt prima dell'invio — istruzioni più chiare, risultati migliori.",
    "refineDelayLabel": "Ritardo affinamento",
    "refineDelayHint": "Countdown prima dell'invio automatico del prompt affinato.",
    "refineLanguageLabel": "Lingua affinamento",
    "refineLanguageHint": "Mantieni la tua lingua o traduci in inglese per il modello.",
    "refineLanguageOriginal": "Originale — mantieni la tua lingua",
    "refineLanguageEnglish": "Inglese — traduci in inglese",
    "reasoningHeading": "Ragionamento e Cache",
    "reasoningModeLabel": "Modalità ragionamento",
    "reasoningModeHint": "Controlla come il modello usa il pensiero esteso. Auto = default del provider.",
    "reasoningModeAuto": "Auto — default del provider",
    "reasoningModeOn": "On — forza pensiero",
    "reasoningModeOff": "Off — disabilita pensiero",
    "reasoningEffortLabel": "Sforzo di ragionamento",
    "reasoningEffortHint": "Quanto compute il modello spende per pensare. Inviato solo se il modello lo supporta.",
    "reasoningEffortNone": "Nessuno",
    "reasoningEffortMinimal": "Minimale",
    "reasoningEffortLow": "Basso",
    "reasoningEffortMedium": "Medio",
    "reasoningEffortHigh": "Alto",
    "reasoningEffortXhigh": "Molto alto",
    "reasoningEffortMax": "Max",
    "preserveThinkingLabel": "Preserva pensiero",
    "preserveThinkingHint": "Mantieni i blocchi di ragionamento tra i turni per la continuità del contesto.",
    "cacheTtlLabel": "TTL Cache",
    "cacheTtlHint": "Time-to-live della cache dei prompt. 1h costa di più in scrittura ma risparmia nelle riletture (Anthropic).",
    "cacheTtlDefault": "Default — default del provider",
    "cacheTtl5m": "5 minuti",
    "cacheTtl1h": "1 ora",
    "capsHint": "Usa wstack models caps per controllare cosa supporta il modello attuale. Le impostazioni non supportate sono omesse silenziosamente per richiesta.",
    "fallbackHeading": "Fallback dei modelli",
    "fallbackBody": "Quando il modello attivo è rate-limited (429/529), in errore 5xx o bloccato — dopo i suoi retry — l'agent ruota al modello successivo in questa catena. Anche usato come default per i sub-agent worker SDD.",
    "autoFallbackLabel": "Fallback automatico",
    "autoFallbackHint": "Quando la catena sopra è vuota, derivane una automaticamente dai tuoi provider con chiave.",
    "favoritesOnlyLabel": "Solo preferiti",
    "favoritesOnlyHint": "Quando il fallback automatico deriva una catena, limitala ai tuoi modelli preferiti.",
    "profilesHeading": "Profili di fallback",
    "addProfile": "Aggiungi",
    "noProfiles": "Nessun profilo di fallback con nome ancora.",
    "createDefault": "Crea default dal modello attivo",
    "useChain": "Usa catena",
    "setLeader": "Imposta leader",
    "profileEmpty": "Il profilo è vuoto.",
    "favoritesHeading": "Modelli preferiti",
    "favoritesEmpty": "I preferiti sono mostrati prima e possono vincolare il fallback automatico.",
    "routingHeading": "Routing dei modelli",
    "routingRouteKey": "Chiave rotta modello",
    "routingPhasesGroup": "Fasi",
    "routingRolesGroup": "Ruoli {{label}}",
    "routingCustomGroup": "Route personalizzate esistenti",
    "routingTargetPlaceholder": "fallback1, provider/model, o vuoto",
    "routingSet": "Imposta",
    "routingReasoningModeAria": "Modalità ragionamento nuova rotta",
    "routingReasoningEffortAria": "Sforzo ragionamento nuova rotta",
    "routingReasoningPreserveAria": "Preservazione ragionamento nuova rotta",
    "routingReasoningModeFor": "Modalità ragionamento per {{key}}",
    "routingReasoningEffortFor": "Sforzo ragionamento per {{key}}",
    "routingReasoningPreserveFor": "Preservazione ragionamento per {{key}}",
    "noRoutes": "Nessuna rotta di modello ancora.",
    "leaderModel": "modello leader",
    "hqHeading": "Client HQ",
    "hqPublishingLabel": "Pubblicazione HQ",
    "hqPublishingHint": "Pubblica questa sessione WebUI/client su WrongStack HQ. I client della stessa macchina possono auto-scoprire l'auth HQ locale; i client remoti usano URL/token sotto.",
    "hqUrlLabel": "URL HQ",
    "hqUrlHint": "Lascia vuoto per auto-scoperta su stessa macchina.",
    "hqTokenLabel": "Token client HQ",
    "executionHeading": "Esecuzione",
    "maxIterationsLabel": "Iterazioni max per run",
    "maxIterationsHint": "Limite rigido di turni LLM per agent.run().",
    "autoProceedMaxIterationsLabel": "Iterazioni max auto-procedere",
    "autoProceedMaxIterationsHint": "Ferma l'auto-procedere dopo N iterazioni. 0 = illimitato.",
    "confirmExitLabel": "Conferma prima di uscire",
    "confirmExitHint": "Primo Ctrl+C annulla il lavoro, secondo conferma l'uscita.",
    "chimeLabel": "Suono al completamento",
    "chimeHint": "Campanello del terminale quando un run dell'agent finisce.",
    "fleetHeading": "Flotta e Streaming",
    "streamFleetLabel": "Stream eventi flotta",
    "streamFleetHint": "Mostra l'attività live dei sub-agent nel pannello flotta.",
    "maxConcurrentLabel": "Sub-agent simultanei max",
    "maxConcurrentHint": "Numero massimo di sub-agent che possono girare simultaneamente.",
    "nextPredictionLabel": "Predizione prossimo passo",
    "nextPredictionHint": "Dopo un turno, predici i probabili passi successivi.",
    "telegramHeading": "Notifiche Telegram",
    "telegramSessionEndLabel": "Fine sessione",
    "telegramSessionEndHint": "Invia un riepilogo quando una sessione finisce.",
    "telegramDelegateLabel": "Delegato terminato",
    "telegramDelegateHint": "Invia una nota umanizzata quando un sub-agent completa.",
    "telegramLongToolLabel": "Strumenti lunghi",
    "telegramLongToolHint": "Notifica quando uno strumento supera {{ms}}ms. 0 per disabilitare.",
    "telegramChangesApply": "Le modifiche si applicano immediatamente.",
    "telegramNotConfigured": "Telegram non è configurato. Esegui /telegram-setup nella CLI per collegare prima un bot.",
    "addModelToProfile": "Aggiungi modello al profilo…",
    "addFavoriteModel": "Aggiungi modello preferito…",
    "hqRawContentLabel": "Contenuto HQ grezzo",
    "hqRawContentHint": "Invia anteprime di contenuto grezze a HQ invece di anteprime censurate."
  },
  "features": {
    "flagsHeading": "Flag di Funzionalità",
    "mcpLabel": "Server MCP",
    "mcpHint": "Abilita le integrazioni Model Context Protocol.",
    "pluginsLabel": "Plugin",
    "pluginsHint": "Carica ed esegui i plugin installati dall'utente.",
    "memoryLabel": "Memoria",
    "memoryHint": "Persisti e richiama fatti tra le sessioni.",
    "skillsLabel": "Competenze",
    "skillsHint": "Carica prompt di competenze specifici del dominio.",
    "modelsRegistryLabel": "Registro modelli",
    "modelsRegistryHint": "Usa il catalogo models.dev per la scoperta dei provider.",
    "indexOnStartLabel": "Indicizza all'avvio",
    "indexOnStartHint": "Costruisci l'indice dei simboli del codebase all'avvio della sessione.",
    "contextHeading": "Contesto e Debug",
    "autoCompactLabel": "Compatta contesto auto",
    "autoCompactHint": "Riduci automaticamente la finestra di contesto vicino ai limiti.",
    "compactorStrategyLabel": "Strategia compattazione",
    "compactorStrategyHint": "Come il contesto viene compattato quando cresce troppo.",
    "compactorStrategyHybrid": "Ibrida — regole veloci (predefinito)",
    "compactorStrategyIntelligent": "Intelligente — sintesi LLM",
    "compactorStrategySelective": "Selettiva — selezione guidata LLM",
    "contextModeLabel": "Modalità contesto",
    "contextModeHint": "Politica della finestra di contesto — bilanciato è il predefinito.",
    "contextModeBalanced": "Bilanciato — uso normale del contesto",
    "contextModeFrugal": "Frugale — uso conservativo di token",
    "contextModeDeep": "Profondo — contesto più ampio per attività complesse",
    "contextModeArchival": "Archivio — massimizza la retention del contesto",
    "tokenSavingLabel": "Modalità risparmio token",
    "tokenSavingHint": "Quanto aggressivamente ridurre l'uso di token.",
    "tokenSavingOff": "Off — nessun risparmio",
    "tokenSavingMinimal": "Minimale — ottimizzazione di base",
    "tokenSavingLight": "Leggero — riduzione moderata",
    "tokenSavingMedium": "Medio — risparmi significativi",
    "tokenSavingAggressive": "Aggressivo — compressione massima",
    "logLevelLabel": "Livello di log",
    "logLevelHint": "Severità minima per il logging lato server.",
    "logLevelDebug": "Debug — tutto",
    "logLevelInfo": "Info — flusso normale",
    "logLevelWarn": "Warn — solo problemi",
    "logLevelError": "Error — solo fallimenti",
    "auditLevelLabel": "Livello di audit",
    "auditLevelHint": "Livello di dettaglio per i log di audit di sessione.",
    "auditLevelMinimal": "Minimale — solo errori",
    "auditLevelStandard": "Standard — chiamate strumenti + errori",
    "auditLevelFull": "Completo — ogni evento (log grandi)"
  },
  "toast": {
    "switchingTo": "Passaggio a {{provider}} / {{model}}…",
    "fallbackExists": "Il profilo di fallback \"{{name}}\" esiste già",
    "selectProviderModelFirst": "Seleziona prima un provider e un modello",
    "defaultProfileCreated": "Profilo di fallback predefinito creato",
    "profileEmpty": "Il profilo di fallback \"{{name}}\" è vuoto",
    "leaderSetFrom": "Leader impostato da {{name}}"
  }
}
